<template>
    <div class="pageBox">
        <div class="pageFrame">
            <left></left>
            <div class="frame">
                <div class="orderCate">
                    <span @click="getOrderList(1)" :class="{on:this.orderState==1}">待付款</span>
                    <span @click="getOrderList(2)" :class="{on:this.orderState==2}">服务中</span>
                    <span @click="getOrderList(3)" :class="{on:this.orderState==3}">已完成</span>
                    <span @click="getOrderList(0)" :class="{on:this.orderState==0}">全部订单</span>
                </div>
                <el-table
                    :data="orderList"
                    stripe
                    border
                    style="width: 100%">
                    <el-table-column
                        prop="orderNumber"
                        label="订单号"
                        align="center"
                        width="170"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="products"
                        label="商品"
                        align="center"
                        width="350"
                    >
                        <router-link
                            :to="{name:'ProductDetail',params:{pId:scope.row.products[0].porductId}}"
                            class="goodsItem"
                            slot-scope="scope">
                            <div class="productImg">
                                <img :src="scope.row.products[0].productImg" :alt="scope.row.products[0].productName">
                            </div>
                            <div class="infoCol">
                                <div class="name">{{ scope.row.products[0].productName }}</div>
                                <div
                                    v-for="(item,index) in scope.row.products[0].productParams"
                                    :key="index"
                                    class="brief">{{ item.productParam }}:{{ item.productParamValue }}
                                </div>
                            </div>
                        </router-link>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="products[0].number"
                        label="数量"
                        width="80"
                    >
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="products[0].totalPrice"
                        width="120"
                        label="总金额(元)">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="operate"
                        label="状态"
                    >
                        <div slot-scope="scope">
                            <div v-show="scope.row.orderStatus==1">
                                <div class="operationRow">
                                    <span class="state">待付款</span>
<!--                                    <div>去支付</div>-->
                                </div>
                            </div>
                            <div v-show="scope.row.orderStatus==2">
                                <div class="operationRow">
                                    <span class="state">服务中</span>
<!--                                    <div>查看订单</div>-->
                                </div>
                            </div>
                            <div v-show="scope.row.orderStatus==3||scope.row.orderStatus==0">
                                <div class="operationRow">
                                    <span class="state">已完成</span>
<!--                                    <div>查看订单</div>-->
                                </div>
                            </div>
                        </div>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="pageIndex"
                        :page-sizes="[10, 15, 20, 25]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount">
                    </el-pagination>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import left from './left'

export default {
    name: "orders",
    components: {
        left,
    },
    mounted() {
        document.title = '我的订单' + this.$suffix
        this.$store.commit('modifyUserIndex', 3001)
        if (!this.$noLoginToLogin()) {
            this.getOrderList(0)
        }
    },
    data() {
        return {
            //订单列表
            orderList: [],
            pageSize: 10,
            pageIndex: 1,
            totalCount: 8,
            isShowDialog: false,
            isShowConfirm: false,
            orderState: 0
        }
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.getOrderList(this.orderState)
        },
        handleCurrentChange(val) {
            this.pageIndex = val
            this.getOrderList(this.orderState)
        },

        /**
         * 获取订单列表
         * @param id 订单状态 0 全部 1 待付款 2 服务中 3 已完成
         */
        getOrderList(id) {
            this.orderState = id
            this.$post('/V1/Order/GetOrdersList',
                {
                    "pageSize": this.pageSize,
                    "pageIndex": this.pageIndex,
                    "orderStatus": id
                })
                .then((res) => {
                    // console.log('order', res)
                    if (res.success) {
                        this.totalCount = res.response.totalCount
                        this.orderList = res.response.data
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },
    }
}
</script>

<style scoped lang="less">

.pageBox {
    width: 100%;
    background-color: #f9f9f9;

    .pageFrame {
        width: 1210px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        padding: 30px 0px;

        .frame {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            width: 880px;
            padding: 40px;
            overflow: hidden;
            background-color: white;

            .orderCate {
                display: flex;
                flex-direction: row;
                align-items: center;
                background-color: #cdcdcd;
                color: #666;
                height: 36px;
                line-height: 36px;
                border: 1px solid #eee;
                border-right: none;
                border-bottom: none;
                font-size: 15px;
                margin-bottom: 20px;

                span {
                    padding: 0px 25px;
                    cursor: pointer;
                    border-right: 1px solid #eee;
                }

                .on, span:hover {
                    color: #1f2d5c;
                    background-color: white;
                    font-weight: bold;
                }
            }

            .goodsItem {
                display: flex;
                flex-direction: row;

                .productImg {
                    width: 100px;
                    min-width: 100px;
                    height: 100px;
                    overflow: hidden;
                    margin-right: 8px;
                    border: 1px solid #cecece;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .infoCol {
                    display: flex;
                    flex-direction: column;

                    .name {
                        font-size: 15px;
                        color: #1f2d5c;
                        line-height: 18px;
                        margin-bottom: 5px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        min-height: 18px;
                    }

                    .brief {
                        color: #666666;
                        line-height: 18px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 5;
                        overflow: hidden;
                    }
                }
            }

            .operationRow {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-around;

                .state{
                    color: #999;
                    font-size: 14px;
                }
            }

            .pagination {
                margin-top: 30px;
            }

            .dialog {
                display: flex;
                flex-direction: column;
                margin: 0 auto;
                width: 540px;
                overflow: hidden;

                .itemRow {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin: 10px 0px;

                    span {
                        min-width: 100px;
                        font-size: 15px;
                    }

                    input {
                        outline: none;
                        border: 1px solid #b6b6b6;
                        border-radius: 5px;
                        padding: 5px 10px;
                        line-height: 26px;
                        font-size: 15px;
                        width: 250px;
                    }
                }
            }
        }
    }
}

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

input[type="number"] {
    -moz-appearance: textfield;
}

</style>
